import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isNil from 'lodash/isNil';
import { Form, withFormik } from 'formik';
import * as Yup from 'yup';
import classNames from 'classnames';
import { Regex } from '../../shared/helpers';
import { Button } from '../Button';
import './References.css';

const References = ({
  references,
  handleAddReference,
  handleDeleteReference,
  handleReferenceInputChange,
  referenceCheckboxesColumn1,
  referenceCheckboxesColumn2,
  referenceCheckboxesColumn3,
  handleChange,
  errors,
  isValid,
}) => {
  const finalReferences = references.filter(reference =>
    isNil(get(reference, '_destroy', null)),
  );

  const getNextId = refs => {
    const referencesIds = refs.map(r => r.internal_id);
    return Math.max(...referencesIds) + 1;
  };

  return (
    <Form className="col-12 col-lg-9 reference-card" autoComplete="off">
      {finalReferences.map((elem, index) => {
        const fieldName = `link.${index}.url`;
        const error = getFieldError(errors, fieldName);
        return (
          <div
            key={String(index)}
            className="card card-project border-0 mb-3 p-lg-3 reference-card__content"
          >
            <div className="card-body">
              <div className="form-row">
                <div className="col">
                  <div className="row align-items-center">
                    <div className="col">
                      <label className={classNames(error && 'text-danger')}>
                        {`Reference Video ${index + 1}`}
                      </label>
                    </div>
                    <div className="col text-right">
                      {finalReferences.length > 1 && (
                        <Button
                          inline
                          className="btn-link t-13 text-uppercase px-3 delete-reference"
                          onClick={e => handleDeleteReference(e, elem)}
                          disabled={
                            !isNil(get(errors, `link[${elem.internal_id}].url`))
                          }
                        >
                          Delete
                        </Button>
                      )}
                    </div>
                    <div className="col-12 mt-4">
                      {' '}
                      <input
                        name={fieldName}
                        className={classNames(
                          'form-control',
                          error && 'is-invalid',
                        )}
                        placeholder="URL"
                        onChange={event => {
                          handleReferenceInputChange(event, elem.internal_id);
                          handleChange(event);
                        }}
                        value={elem.link}
                      />
                      {error && (
                        <div className="invalid-feedback d-block">{error}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col-12 mt-3">
                  <p className="t-14 font-weight-bold mb-2">
                    What do you like about this reference video?
                  </p>
                </div>
                <div className="col-12 reference-card__checkboxes">
                  <div className="row">
                    <div className="col-9">
                      <div className="row">
                        {referenceCheckboxesColumn1.map((check, idx) => (
                          <div
                            className="col-12 col-lg-4 mb-2"
                            key={String(idx)}
                          >
                            <div className="custom-control custom-checkbox eference-card">
                              <input
                                type="checkbox"
                                name="checkboxes"
                                value={check}
                                id={`refence-check-${idx}-${elem.internal_id}`}
                                className="custom-control-input"
                                checked={elem.checkboxes.includes(check)}
                                onChange={event =>
                                  handleReferenceInputChange(
                                    event,
                                    elem.internal_id,
                                  )
                                }
                              />
                              <label
                                className="custom-control-label t-15"
                                htmlFor={`refence-check-${idx}-${
                                  elem.internal_id
                                }`}
                              >
                                {check}
                              </label>
                            </div>
                          </div>
                        ))}

                        {referenceCheckboxesColumn2.map((check, idx) => (
                          <div
                            className="col-12 col-lg-4 mb-2"
                            key={String(idx)}
                          >
                            <div className="custom-control custom-checkbox reference-card__checkboxes-element">
                              <input
                                type="checkbox"
                                name="checkboxes"
                                value={check}
                                id={`refence-check-c-${idx}-${
                                  elem.internal_id
                                }`}
                                className="custom-control-input"
                                checked={elem.checkboxes.includes(check)}
                                onChange={event =>
                                  handleReferenceInputChange(
                                    event,
                                    elem.internal_id,
                                  )
                                }
                              />
                              <label
                                className="custom-control-label t-15"
                                htmlFor={`refence-check-c-${idx}-${
                                  elem.internal_id
                                }`}
                              >
                                {check}
                              </label>
                            </div>
                          </div>
                        ))}

                        {referenceCheckboxesColumn3.map((check, idx) => (
                          <div
                            className="col-12 col-lg-4 mb-2"
                            key={String(idx)}
                          >
                            <div className="custom-control custom-checkbox reference-card__checkboxes-element">
                              <input
                                type="checkbox"
                                name="checkboxes"
                                value={check}
                                id={`refence-check-b-${idx}-${
                                  elem.internal_id
                                }`}
                                className="custom-control-input"
                                checked={elem.checkboxes.includes(check)}
                                onChange={event =>
                                  handleReferenceInputChange(
                                    event,
                                    elem.internal_id,
                                  )
                                }
                              />{' '}
                              <label
                                className="custom-control-label t-15"
                                htmlFor={`refence-check-b-${idx}-${
                                  elem.internal_id
                                }`}
                              >
                                {check}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 mt-3">
                  <textarea
                    rows="3"
                    placeholder="Add more specific comments..."
                    className="form-control reference-card__textarea"
                    name="comment"
                    onChange={event =>
                      handleReferenceInputChange(event, elem.internal_id)
                    }
                    value={elem.comment}
                  />
                </div>
                {index + 1 !== references.length && (
                  <div className="reference-card__separator" />
                )}
              </div>
            </div>
          </div>
        );
      })}
      {finalReferences.length > 5 ? (
        <label className="project-brief-card__uploader--disabled">
          <span className="project-brief-card__uploader--icon" />
          Up to 6 URL maximum
        </label>
      ) : (
        <a
          onClick={event =>
            handleAddReference(event, getNextId(finalReferences))
          }
          className="t-15 text-center add-reference"
          disabled={!isValid}
        >
          + ADD ANOTHER VIDEO URL
        </a>
      )}
    </Form>
  );
};

const getFieldError = (errors, fieldName) => get(errors, fieldName);

References.propTypes = {
  errors: PropTypes.object,
  isValid: PropTypes.bool,
  references: PropTypes.array,
  handleChange: PropTypes.func,
  handleAddReference: PropTypes.func,
  handleDeleteReference: PropTypes.func,
  handleReferenceInputChange: PropTypes.func,
  referenceCheckboxesColumn1: PropTypes.array,
  referenceCheckboxesColumn2: PropTypes.array,
  referenceCheckboxesColumn3: PropTypes.array,
};

const ReferencesForm = withFormik({
  validateOnBlur: true,
  validateOnChange: true,
  enableReinitialize: true,
  validationSchema: Yup.object().shape({
    link: Yup.array().of(
      Yup.object().shape({
        url: Yup.string()
          .matches(Regex.site, 'This video URL is not valid')
          .nullable(),
      }),
    ),
  }),
  displayName: 'ReferencesForm',
})(References);

export default ReferencesForm;



// WEBPACK FOOTER //
// ./src/components/References/References.js